//import { AuthContext } from '@@/modules/global/common/contexts/AuthContext';
import React, { useContext, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import UnauthorizedPage from '@@/products/portal/pages/unauthorized-access-page';
import { Box, Spinner } from '@cloudscape-design/components';
import { determineUserPermissions } from '@@/lib/permissions';
import { AuthContext } from '@@/contexts/AuthContext';
import centenePermissionMapping, { CentenePermission } from '../common/permission-mappings';

const CenteneAuthorizer = () => {
  const { instanceData, loading, error } = useContext(AuthContext);
  const { pathname } = useLocation();

  const userPermissions = useMemo(() => {
    if (!instanceData?.permissions) return new Set<CentenePermission>();
    return determineUserPermissions(instanceData.permissions, pathname, centenePermissionMapping);
  }, [instanceData?.permissions, pathname]);

  if (loading) {
    return (
      <Box padding='xxl' textAlign='center'>
        <Spinner size='large' />
      </Box>
    );
  }

  if (error) {
    return <div aria-label={'API Error'}>API Error: {error.toString()}</div>;
  }

  if (userPermissions && userPermissions.size > 0) {
    return <Outlet context={{ permissions: userPermissions }} />;
  }

  return <UnauthorizedPage />;
};

export default CenteneAuthorizer;
